import { IUserStore } from '../../user/store';
import { IAdminFlight } from '../eventFlights/store';

export interface IEventEnrollment {
  event: number;
  flight: IAdminFlight | null;
  handicap: number;
  id: number;
  index: number;
  manualHandicap: boolean;
  playerNote?: string;
  status: string;
  tee: string;
  user: IUserStore;
}

export interface IAdminEventEnrollmentsStore {
  [clubId: number]: IEventEnrollment[];
}

export const adminEventEnrollmentsStore: IAdminEventEnrollmentsStore = {};
